module.exports = __webpack_public_path__ + "static/media/seattle-2-compressed.cd9ddf07.jpg";